import { useEffect } from 'react';

import { useAuthContext } from 'contexts/AuthContext';

import LayoutWithMenu from '../components/Layout/LayoutWithMenu';

export const LogoutPage = () => {
  const { logout } = useAuthContext();
  useEffect(() => {
    logout().then(() => {
      window.location.href = '/auth/login'; // Redirect to login after logout
      // do not let user come back to the /auth/logout page by browser back buttons
      window.history.replaceState({}, '', '/auth/login');
    });
  }, [logout]);

  return (
    <LayoutWithMenu>
      <div style={{ fontSize: 16, textAlign: 'center', padding: '48px 16px' }}>
        Logging out...
      </div>
    </LayoutWithMenu>
  );
};
